import React from 'react';

const DesktopAndTabletContainerFull = props => {
  return <div className="br-md full" {...props} />;
};

export default DesktopAndTabletContainerFull;
